// extracted by css-extract-rspack-plugin
export default {"cls1":"CoauthorConfirmationCard-cls1_q7b","cls2":"CoauthorConfirmationCard-cls2_jCu CoauthorConfirmationCard-cls1_q7b"};